module.exports = __webpack_public_path__ + "img/logo_daiso.9dda2d0.svg";